// Import and register all your controllers
import { application } from "./application"

// Import all controllers
import BankAccountItemController from "./bank_account_item_controller"
import BankAccountsController from "./bank_accounts_controller"
import BatchEditModalController from "./batch_edit_modal_controller"
import BillingInfoFormController from "./billing_info_form_controller"
import BillingTabsController from "./billing_tabs_controller"
import BrowserNavigationController from "./browser_navigation_controller"
import BulkLineUpdateController from "./bulk_line_update_controller"
import BuyerSellerSettingsController from "./buyer_seller_settings_controller"
import CompanyAutocompleteController from "./company_autocomplete_controller"
import CompanyDefaultsController from "./company_defaults_controller"
import CompanyDeleteController from "./company_delete_controller"
import CompanyFormController from "./company_form_controller"
import CompanyNameUnifiedController from "./company_name_unified_controller"
import CompanyRowController from "./company_row_controller"
import CompanyTypeSwitcherController from "./company_type_switcher_controller"
import CompanyVerificationController from "./company_verification_controller"
import ConfirmationModalController from "./confirmation_modal_controller"
import CustomFieldFiltersController from "./custom_field_filters_controller"
import DateFilterInlineController from "./date_filter_inline_controller"
import DefaultMemoryTrayController from "./default_memory_tray_controller"
import DefaultsRowController from "./defaults_row_controller"
import DelayedNavigationController from "./delayed_navigation_controller"
import DocumentTabsController from "./document_tabs_controller"
import DocumentDetailsDropdownController from "./document_details_dropdown_controller"
import DrawerController from "./drawer_controller"
import DropdownController from "./dropdown_controller"
import DropzoneController from "./dropzone_controller"
import ExportableToggleController from "./exportable_toggle_controller"
import FilterPillController from "./filter_pill_controller"
import FilterPopoverController from "./filter_popover_controller"
import FlashController from "./flash_controller"
import FormComboboxController from "./form_combobox_controller"
import FormCompanySelectorController from "./form_company_selector_controller"
import FormDropdownController from "./form_dropdown_controller"
import FormVatSelectorController from "./form_vat_selector_controller"
import InvoiceActionsDropdownController from "./invoice_actions_dropdown_controller"
import InvoiceFormValidationController from "./invoice_form_validation_controller"
import NextActionController from "./next_action_controller"
import InvoiceRowController from "./invoice_row_controller"
import InvoiceSelectionController from "./invoice_selection_controller"
import LineItemController from "./line_item_controller"
import LineItemColumnsController from "./line_item_columns_controller"
import LineItemsController from "./line_items_controller"
import LineTabsController from "./lines_tabs_controller"
import LookupAccordionController from "./lookup_accordion_controller"
import LookupCreateModalController from "./lookup_create_modal_controller"
import LookupSelectorController from "./lookup_selector_controller"
import ManualUploadExceptionsController from "./manual_upload_exceptions_controller"
import MobileMenuController from "./mobile_menu_controller"
import ModalController from "./modal_controller"
import OperationTypeController from "./operation_type_controller"
import PdfViewerController from "./pdf_viewer_controller"
import ResizableTableController from "./resizable_table_controller"
import ReviewRequirementToggleController from "./review_requirement_toggle_controller"
import SearchFormController from "./search_form_controller"
import ScrollSpyController from "./scroll_spy_controller"
import SimpleEditModalController from "./simple_edit_modal_controller"
import SplitPanelController from "./split_panel_controller"
import ExportChooserController from "./export_chooser_controller"
import SubmitProtectionController from "./submit_protection_controller"
import TeamActionsController from "./team_actions_controller"
import TableLoadingController from "./table_loading_controller"
import VatInputController from "./vat_input_controller"
import VatLineController from "./vat_line_controller"
import VatLineItemController from "./vat_line_item_controller"

// Register all controllers
application.register("bank-account-item", BankAccountItemController)
application.register("bank-accounts", BankAccountsController)
application.register("batch-edit-modal", BatchEditModalController)
application.register("billing-info-form", BillingInfoFormController)
application.register("billing-tabs", BillingTabsController)
application.register("browser-navigation", BrowserNavigationController)
application.register("bulk-line-update", BulkLineUpdateController)
application.register("buyer-seller-settings", BuyerSellerSettingsController)
application.register("company-autocomplete", CompanyAutocompleteController)
application.register("company-defaults", CompanyDefaultsController)
application.register("company-delete", CompanyDeleteController)
application.register("company-form", CompanyFormController)
application.register("company-name-unified", CompanyNameUnifiedController)
application.register("company-row", CompanyRowController)
application.register("company-type-switcher", CompanyTypeSwitcherController)
application.register("company-verification", CompanyVerificationController)
application.register("confirmation-modal", ConfirmationModalController)
application.register("custom-field-filters", CustomFieldFiltersController)
application.register("date-filter-inline", DateFilterInlineController)
application.register("default-memory-tray", DefaultMemoryTrayController)
application.register("defaults-row", DefaultsRowController)
application.register("delayed-navigation", DelayedNavigationController)
application.register("document-tabs", DocumentTabsController)
application.register("document-details-dropdown", DocumentDetailsDropdownController)
application.register("drawer", DrawerController)
application.register("dropdown", DropdownController)
application.register("dropzone", DropzoneController)
application.register("exportable-toggle", ExportableToggleController)
application.register("filter-pill", FilterPillController)
application.register("filter-popover", FilterPopoverController)
application.register("flash", FlashController)
application.register("form-combobox", FormComboboxController)
application.register("form-company-selector", FormCompanySelectorController)
application.register("form-dropdown", FormDropdownController)
application.register("form-vat-selector", FormVatSelectorController)
application.register("invoice-actions-dropdown", InvoiceActionsDropdownController)
application.register("invoice-form-validation", InvoiceFormValidationController)
application.register("next-action", NextActionController)
application.register("invoice-row", InvoiceRowController)
application.register("invoice-selection", InvoiceSelectionController)
application.register("line-item", LineItemController)
application.register("line-item-columns", LineItemColumnsController)
application.register("line-items", LineItemsController)
application.register("lines-tabs", LineTabsController)
application.register("lookup-accordion", LookupAccordionController)
application.register("lookup-create-modal", LookupCreateModalController)
application.register("lookup-selector", LookupSelectorController)
application.register("manual-upload-exceptions", ManualUploadExceptionsController)
application.register("mobile-menu", MobileMenuController)
application.register("modal", ModalController)
application.register("operation-type", OperationTypeController)
application.register("pdf-viewer", PdfViewerController)
application.register("resizable-table", ResizableTableController)
application.register("review-requirement-toggle", ReviewRequirementToggleController)
application.register("search-form", SearchFormController)
application.register("scroll-spy", ScrollSpyController)
application.register("simple-edit-modal", SimpleEditModalController)
application.register("split-panel", SplitPanelController)
application.register("export-chooser", ExportChooserController)
application.register("submit-protection", SubmitProtectionController)
application.register("team-actions", TeamActionsController)
application.register("table-loading", TableLoadingController)
application.register("vat-input", VatInputController)
application.register("vat-line", VatLineController)
application.register("vat-line-item", VatLineItemController)
